import React from 'react';

import {Grid} from '@mui/material';

import {Head} from '@wheeebo/polaris-ui';

import AccountCard from '@components/pages/home/AccountCard';

function HomePage(): JSX.Element {
  return (
    <Grid container spacing={1 / 2}>
      <Head title="Home" />
      <Grid item xs={12} sm={3}>
        <AccountCard />
      </Grid>
    </Grid>
  );
}

export default React.memo(HomePage);
